export enum ReportStatus {

  PAST_DUE,

  PENDING,

  SUBMITTED

}

export namespace ReportStatus {

  export function fromString(name: string): ReportStatus {
    return ReportStatus[name];
  }

}
